import React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { stringify } from "qs";

import { clearKeysFromQuery } from "hooks/useClearQueryStringKeys";
import parseNextRouterAsPath from "utils/parseNextRouterAsPath";

import NotFoundIcon from "components/Icons/not_found.svg";

const ShopNoResults: React.FC<{
  buttonText: string;
  subtitleText: string;
  titleText: string;
  wrapperClassName?: string;
}> = ({ buttonText, subtitleText, titleText, wrapperClassName }) => {
  const { asPath } = useRouter();
  const { path, query } = parseNextRouterAsPath(asPath);

  return (
    <div className={wrapperClassName}>
      <div className="border border-light-grey rounded flex flex-col items-center gap-lg p-lg">
        <div className="flex flex-col items-center gap-sm">
          <NotFoundIcon width={48} />
          <h1 className="font-bold text-md text-center">{titleText}</h1>
        </div>
        {subtitleText && <p className="mb-none text-center">{subtitleText}</p>}
        <Link
          className="button button--secondary"
          data-testid="unified-shop-no-results-button"
          href={{
            pathname: path,
            query: stringify(
              clearKeysFromQuery(query, ["filter", "fulfillment"]),
              {
                arrayFormat: "brackets",
                indices: false,
              },
            ),
          }}
        >
          {buttonText}
        </Link>
      </div>
    </div>
  );
};

export default ShopNoResults;
